import React from 'react';
import { Heart, ExternalLink } from 'lucide-react';

const MemorialSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border border-white rounded-full" />
          <div className="absolute bottom-10 right-10 w-48 h-48 border border-white rounded-full" />
        </div>
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-rose-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          {/* Memorial Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-rose-500/20 text-rose-300 rounded-full text-sm font-semibold mb-6">
            <Heart className="w-4 h-4" />
            In Loving Memory
          </div>

          {/* Name */}
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Maurice R. Sykes
          </h2>

          {/* Description */}
          <p className="text-xl text-slate-300 leading-relaxed mb-8 max-w-3xl mx-auto">
            Maurice R. Sykes dedicated his life to advancing early childhood education in Washington, DC. 
            His vision, leadership, and unwavering belief in every child's potential continue to inspire DCELC's mission. 
            Honor his legacy by supporting the work he loved.
          </p>

          {/* Donation Link */}
          <a
            href="https://donate.thecommunityfoundation.org/give/696733/#!/donation/checkout"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-rose-500 to-rose-600 hover:from-rose-600 hover:to-rose-700 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group"
            data-testid="honor-legacy-btn"
          >
            <Heart className="w-5 h-5" />
            Honor His Legacy
            <ExternalLink className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default MemorialSection;
